import { render, staticRenderFns } from "./Braiding.vue?vue&type=template&id=04b52333&lang=pug&"
import script from "./Braiding.vue?vue&type=script&lang=ts&"
export * from "./Braiding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports